import { StatusSchema } from '../../services/StatusService/StatusService.schemas';
import {
  StatusPerk,
  StatusPerkType,
  PerksConfigState,
  StatusPerkUpgradeType,
} from './perksConfig.types';

export const buildInitialState = () =>
  StatusSchema.options.reduce(
    (accumulator, status) => ({
      ...accumulator,
      [status]: {
        status,
        perks: [],
      },
    }),
    {} as Required<PerksConfigState>['data'],
  );

export const groupPerksByType = (perks: StatusPerk[]) =>
  perks.reduce(
    (acc, item) => {
      acc[item.type] = item;
      return acc;
    },
    {} as Record<StatusPerkType, StatusPerk>,
  );

export const getPerkUpgradeType = ({
  nextStatusPerk,
  currentStatusPerk,
}: {
  nextStatusPerk: StatusPerk;
  currentStatusPerk: StatusPerk;
}): StatusPerkUpgradeType => {
  // is a brand new perk
  if (!currentStatusPerk) {
    return 'ReachNextStatusToUnlock';
  }

  // is a value perk
  if (currentStatusPerk.value && nextStatusPerk.value) {
    return nextStatusPerk.value > currentStatusPerk.value
      ? 'ReachNextStatusForMore'
      : 'KeepInNextStatus';
  }

  // is NOT a value perk
  return 'KeepInNextStatus';
  // INFO: if we want to handle progressive perks at some point it will look like this
  // Progressive perks are non-value perks that become better in the next status
  // return isProgressive ? 'ReachNextStatusToUpgrade' : 'KeepInNextStatus';
};
